// Utils functions
import * as moment from 'moment';
import * as dao from './dao';

// WARNING This could crash
export const padZero = (num:number|string, pad:number) => num.toString().padStart(pad, '0');	// Simple function to pad 0 to the left of a 1 long number

export function tofseformat(dateInput: string | Date | moment.Moment): string {// s is a date string formatted as "dd/mm/yyyy" (OR "dd-mm-yyyy") OR a date. Returns a string formatted as yyyymmdd OR undefined
  // If input is a Date, convert to "DD/MM/YYYY" string
	//console.log('[tofseformat] dateInput / typeof: ', dateInput, typeof dateInput);
  let dateString: string;
	if (dateInput instanceof Date) {
	  dateString = dateInput.toLocaleDateString('fr_FR');
	} else if (typeof dateInput === 'string') {
	  dateString = dateInput;
	} else if (moment.isMoment && moment.isMoment(dateInput)) {
	  dateString = dateInput.format('DD/MM/YYYY');
	} else {
	  throw new Error('Input must be a string, Date, or moment.Moment');
	}

  if (dateString === '') return '';
  dateString = dateString.replaceAll('-', "/"); // In case one types 21-12-2015
  dateString = dateString.replaceAll('.', "/"); // In case one types 21.12.2015

  // if (!isValidDate(dateString)) return undefined; // Commented out. Month CAN be > 12!
  const parts = dateString.split("/");
  if (parts.length !== 3) {
    console.error("Format de date invalide (format FR attendu) : " + dateString);
    throw new Error("Format de date invalide (format FR attendu) : " + dateString);
  }
  const day = parts[0];
  const month = parts[1]; // Month can be 19!
  const year = parts[2];
  //console.log(`[tofseformat] input-day-month-year ${dateString} ${day} ${month} ${year}`);

  return year + padZero(month, 2) + padZero(day, 2);
}

export function toFRformat(dateString: string|undefined): string {	// s is a date string formatted as "dd/mm/yyyy" (OR "yyyymmdd"). Returns a string formatted as dd/mm/yyyy OR undefined
	//if (!isValidDate(dateString)) return undefined;	// TODO code a validation function
	if (!dateString || dateString.length !== 8) return '';
	var year = dateString.substring(0,4);
	var month = dateString.substring(4,6);
	var day = dateString.substring(6);
	return day + '/' + month + '/' + year;
}

export function isoToFse(isoDateString?: string): string | undefined { // Function to format an iso string date as YYYYMMDD
	if (!isoDateString) return undefined;   

	const date = new Date(isoDateString);		// Create a Date object from the ISO 8601 string
  
  if (isNaN(date.getTime()))  return undefined;	// Check if the date is valid

  // Format the date as YYYYMMDD
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}${month}${day}`;
}

export function fromFRformat(dateString: string ): Date {	// Return a Date from FR (dd/mm/yyy) format or throw an error
		if (!dateString || !isValidDate(dateString)) {
			console.error("Format de date invalide : " + dateString);
			throw new Error("Format de date invalide : " + dateString);
		}
		
    // Split the date string into components
    const parts = dateString.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Months are 0-based in JS Date
    const year = parseInt(parts[2], 10);

    // Return the new Date object
    return new Date(year, month, day);
}

// Weak version of tofseformat. Param is a date
export function dateTofseFormat(dat: Date = new Date()): string {			// Input: a date OR undefined, Output a fse formatted date 
	return dat.getFullYear() + padZero(dat.getMonth()+1, 2) + padZero(dat.getDate(), 2);	// Format as yyyymmdd
}

// Converts a date string in "YYYYMMDD" (fse) format to a Date object.
export function getDateFromYYYYMMDD(dateString?: string): Date {
	const regex = /^(19|20)\d{2}\d{2}\d{2}$/;
	if (!dateString || !regex.test(dateString)) {
		console.error("Format de date invalide : " + dateString);
	  throw new Error("Format de date invalide : " + dateString);
	}
  const year = parseInt(dateString.substring(0, 4), 10);
  const monthindex = parseInt(dateString.substring(4, 6), 10) - 1; // Months are zero-based in JavaScript Date
  const day = parseInt(dateString.substring(6, 8), 10);
  
  return new Date(year, monthindex, day);
}

// TEMPLATE for string formatting functions
// Change date format: fse to FR formated YYYYMMDD -> dd/mm/yyyy
// If strict, do NOT allow empty input string. dat MUST be well formed
// Return a string OR '' if !strict OR throws an exception. Never returns undefined
export function getDateStringFromYYYYMMDD (dat:string | undefined, strict:boolean=false): string { // YYYYMMDD -> dd/mm/yyyy
	//console.log(`[getDateStringFromYYYYMMDD] input ${dat}`); 
	if (!strict && (dat=='' || dat==undefined)) return '';
	const regex = /^(19|20)\d{2}\d{2}\d{2}$/;
	if (!dat || !regex.test(dat)) {
		console.error("Format de date invalide : " + dat);
	  throw new Error("Format de date invalide : " + dat);
	}
	const year = dat.substring(0, 4);
	const month = dat.substring(4, 6); 
	const day = dat.substring(6, 8);	
	//console.log(`[getDateStringFromYYYYMMDD] input-day-month-year ${dat} ${day} ${month} ${year}`); 
	return `${day}/${month}/${year}`;
}

// Returns the current date in ISO format (YYYY-MM-DD) without the time part. 
// If a Date object is provided as an optional parameter, it returns the date from the provided Date object instead.
export function getCurrentDateISO(date: Date|undefined): string {		
    const currentDate = date || new Date();
    const year = currentDate.getUTCFullYear();
    const month = String(currentDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getUTCDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
}

export function isValidDate(dateString: string): boolean	// Validates that the input string is a valid date formatted as "dd/mm/yyyy"
{
	// First check for the pattern
	if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
		return false;

	// Parse the date parts to integers
	var parts = dateString.split("/");
	var day = parseInt(parts[0], 10);
	var month = parseInt(parts[1], 10);
	var year = parseInt(parts[2], 10);

	// Check the ranges of month and year
	if (year < 1000 || year > 3000 || month == 0 || month > 12)
		return false;

	var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

	// Adjust for leap years
	if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
		monthLength[1] = 29;

	// Check the range of the day
	return day > 0 && day <= monthLength[month - 1];
};

export class ProcessingResult {	// Utility class to store some results as strings
		info: string[];
    warnings: string[];
    errors: string[];
		fatal: string[];
		areaResponse?: dao.AreaResponseType;
		
    constructor(warnings: string[] = [], errors: string[] = [], fatal: string[] = [], info: string[] = [], areaResponse: dao.AreaResponseType|undefined = undefined) { this.warnings = warnings; this.errors = errors; this.fatal = fatal; this.info = info; this.areaResponse = areaResponse; }
    addWarning(warning: string): void { this.warnings.push(warning); }
    addError(error: string): void { this.errors.push(error); }
		addFatal(fatalError: string): void { this.fatal.push(fatalError); }
		addInfo(info: string): void { this.info.push(info); }
		setAreaResponse(areaResponse: any): void { this.areaResponse = areaResponse; }
		clear(): void { this.warnings = []; this.errors = []; this.fatal = []; ; this.info = []; this.areaResponse=undefined; }
		isFilled():boolean { return(this.info.length!==0 || this.warnings.length!==0 || this.errors.length!==0 || this.fatal.length!==0) }
		isError():boolean { return(this.warnings.length!==0 || this.errors.length!==0 || this.fatal.length!==0) }
}

export function getStation(): any | undefined {			// Get station from storage
	//console.log('utils.getStation()');	
	let token_station = localStorage.getItem("station");
	if (token_station) {
		//console.log('station: ', token_station);
		return JSON.parse(token_station);
	}
	console.error('station not found!');	
	return undefined;	// No current station 
}	

// Helper function to remove empty property from obj
export function removeEmptyProperty(obj: any, key:string) {
 if (obj[key] === null || obj[key] === undefined || obj[key] === '' || (Array.isArray(obj[key]) && obj[key].length === 0)) {
   //console.log (`IS TO BE REMOVED: ${key} nb prop left: ` + Object.keys(obj).length);
   delete obj[key];
  }
}